export default {"src":"/_next/static/media/pair-2.bfc6b3f7.svg","height":485,"width":527,"blurWidth":0,"blurHeight":0};